module.exports = __webpack_public_path__ + "img/gjj-ios.9985e896.png";